export default {
  default: () => import("D:/App/Qrgateway.com/homepage_n3.2/layouts/default.vue").then(m => m.default || m),
  qrcode: () => import("D:/App/Qrgateway.com/homepage_n3.2/layouts/qrcode.vue").then(m => m.default || m)
}